'use client';

import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';
import { ButtonColor, ButtonVariant } from '@/components/ui/button/button.types';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';

interface TelemedicineScheduleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  color?: ButtonColor;
  className?: string;
  ['data-analytics-event']?: AnalyticsEnumKeyType;
  from?: string;
  sessionName?: string;
}

export const TelemedicineScheduleButton = ({
  variant = 'default',
  color = 'success',
  className,
  from,
  sessionName,
  'data-analytics-event': analyticsEventName,
  ...rest
}: TelemedicineScheduleButtonProps) => {
  return (
    <Button
      data-testid={DataTestIdEnum.CITY_TELEMEDICINE_SCHEDULE_BUTTON}
      variant={variant}
      color={color}
      startIcon={faCalendarCheck}
      className={cn('h-12', className)}
      {...rest}
      data-analytics-event={analyticsEventName}
      data-analytics-properties={JSON.stringify({
        secao_origem: from,
        nome_secao: sessionName,
      })}
      onClick={(event) => {
        rest.onClick?.(event);
        handleOpenSearchModal({ searchTerm: 'teleconsulta' });
      }}
    >
      Agendar teleconsulta
    </Button>
  );
};
